// TO CREATE FLN ACTIVITY SKILL

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import api from "../../api/api";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import { red, blue, green, purple, orange } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";

// import {
//   usertype_change_skill,
//   activityType_change_skill,
//   language_change_skill,
//   program_change_skill,
//   clas_change_skill,
//   level_change_skill,
//   subject_change_skill,
//   clear_data_skill,
// } from "./FlnSkillSlice";

import {
  usertype_change_skill,
  activityType_change_skill,
  language_change_skill,
  program_change_skill,
  clas_change_skill,
  level_change_skill,
  subject_change_skill,
  clear_data_skill,
} from "../FlnSkill/FlnSkillSlice";

// import {
//   getTeacherBaselineFlnThunkSkill,
//   getTeacherBaselinePgeThunkSkill,
//   getTeacherBaselineEceThunkSkill,
//   deleteTeacherBaselineThunk,
// } from "./FlnSkillsThunk";
import {
  getTeacherBaselineFlnThunkSkill,
  getTeacherBaselinePgeThunkSkill,
  getTeacherBaselineEceThunkSkill,
  deleteTeacherBaselineThunk,
} from "../FlnSkill/FlnSkillThunk";

const FlnSkillsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { skill } = useSelector((state) => state.FlnSkillSlice);
  console.log("data--->", skill);
  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, skillId, skillName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(skillId);
    setSelectedSkillsetName(skillName);
  };
  const [updateData, setUpdateData] = useState({
    skillId: "",
    skillName: "",
  });
  console.log("openVertMenu", openVertMenu);
  const handleVertMenuClose = () => {
    // setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    clearState();
    navigate("/flnactivity");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "cci", text: "CCI" },
  ];

  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const activitytype_select_option_list = [
    { value: "fln", text: "FLN" },
    { value: "ece", text: "ECE" },
    { value: "pge", text: "PGE" },
    // { value: "community", text: "Community" },
  ];
  const program_select_option_list = [
    { value: "pge", text: "PGE" },
    { value: "ece", text: "ECE" },
  ];

  const clas_select_option_list = [
    { value: 1, text: "ଶ୍ରେଣୀ ୧" },
    { value: 2, text: "ଶ୍ରେଣୀ ୨" },
    { value: 3, text: "ଶ୍ରେଣୀ ୩" },
    { value: 4, text: "ଶ୍ରେଣୀ ୪" },
    { value: 5, text: "ଶ୍ରେଣୀ ୫" },
    { value: 6, text: "ଶ୍ରେଣୀ ୬" },
    { value: 7, text: "ଶ୍ରେଣୀ ୭" },
    { value: 8, text: "ଶ୍ରେଣୀ ୮" },
  ];

  const Fln_level_select_option_list = [
    // { value: "1", text: "Level 1 (Age 3-4 Years)" },
    // { value: "2", text: "Level 2 (Age 4-5 Years)" },
    { value: 3, text: "Level 3 (Balvatika)" },
  ];

  const level_select_option_list = [
    { value: 1, text: "Level 1 (Age 3-4 Years)" },
    { value: 2, text: "Level 2 (Age 4-5 Years)" },
    { value: 3, text: "Level 3 (Balvatika)" },
  ];

  const subject_select_option_list = [
    { value: "foundationalLiteracy", text: "Foundational Literacy" },
    { value: "foundationalNumeracy", text: "Foundational Numeracy" },
  ];
  const subjects_select_option_list = [
    { value: "maths", text: "Math" },
    { value: "odia", text: "Odia" },
    { value: "english", text: "English" },
    { value: "evs", text: "E.V.S." },
  ];

  // ------------ dropdowns on change ----------------
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change_skill(event.target.value));
  };
  const activitytype_select_onchange = (event) => {
    dispatch(program_change_skill(""));
    dispatch(level_change_skill(""));
    dispatch(clas_change_skill(""));
    dispatch(subject_change_skill(""));
    dispatch(clear_data_skill());
    dispatch(activityType_change_skill(event.target.value));
    // if (event.target.value === "community") {
    //   const body = {
    //     activityType: event.target.value,
    //     usertype,
    //     language,
    //   };
    //   dispatch(getTeacherBaselineCommunityThunk(body));
    // }
  };
  const language_select_onchange = (event) => {
    dispatch(language_change_skill(event.target.value));
  };
  const program_select_onchange = (event) => {
    dispatch(program_change_skill(event.target.value));
    dispatch(level_change_skill(""));
    dispatch(clas_change_skill(""));
    dispatch(subject_change_skill(""));
    dispatch(clear_data_skill());
  };
  const clas_select_onchange = (event) => {
    dispatch(clas_change_skill(event.target.value));
    dispatch(level_change_skill(""));
    dispatch(subject_change_skill(""));
    dispatch(clear_data_skill());
  };
  const level_select_onchange = (event) => {
    dispatch(level_change_skill(event.target.value));
    dispatch(subject_change_skill(""));
    dispatch(clear_data_skill());
  };
  const subject_select_fln_pge_onchange = (event) => {
    dispatch(subject_change_skill(event.target.value));
    const params = {
      activityType,
      usertype,
      language,
      program,
      quizClass: clas,
      subject: event.target.value,
    };
    console.log("params---->", params);
    dispatch(getTeacherBaselineFlnThunkSkill(params));
  };

  const subject_select_fln_ece_onchange = (event) => {
    dispatch(subject_change_skill(event.target.value));
    const params = {
      activityType,
      usertype,
      language,
      program,
      quizClass: level,
      subject: event.target.value,
    };
    console.log("params---->", params);
    dispatch(getTeacherBaselineFlnThunkSkill(params));
  };
  const subject_select_pge_onchange = (event) => {
    dispatch(subject_change_skill(event.target.value));
    const params = {
      activityType,
      usertype,
      language,
      quizClass: clas,
      subject: event.target.value,
    };
    console.log("params pge---->", params);
    dispatch(getTeacherBaselinePgeThunkSkill(params));
  };

  const level_select_ece_onchange = (event) => {
    dispatch(level_change_skill(event.target.value));
    const params = {
      activityType,
      usertype,
      language,
      quizClass: event.target.value,
    };
    console.log("params ece---->", params);
    dispatch(getTeacherBaselineEceThunkSkill(params));
  };

  // ------------ Load data & skill ----------------

  const skillId = useSelector((state) => state.FlnSkillSlice.skillId);
  const skillName = useSelector((state) => state.FlnSkillSlice.skillName);
  const usertype = useSelector((state) => state.FlnSkillSlice.usertype);
  const activityType = useSelector((state) => state.FlnSkillSlice.activityType);
  const language = useSelector((state) => state.FlnSkillSlice.language);
  const program = useSelector((state) => state.FlnSkillSlice.program);
  const clas = useSelector((state) => state.FlnSkillSlice.clas);
  console.log("clas-------------->", clas);
  const level = useSelector((state) => state.FlnSkillSlice.level);
  const subject = useSelector((state) => state.FlnSkillSlice.subject);
  const disable_content_button = useSelector(
    (state) => state.FlnSkillSlice.disable_content_button
  );

  // useEffect(() => {
  //   const load_data = () => {
  //     const body = {
  //       activityType: "fln",
  //       usertype: usertype,
  //       language: "od",
  //       program: program,
  //       class: clas,
  //       subject: subject
  //     }
  //     dispatch(getTeacherBaselineThunk(body));
  //   };
  //   load_data();
  // } );

  // -----------------------------------------------

  // ----------- create, update delete button click ----------
  const create_content_button_click_fln = () => {
    Swal.fire({
      title: "CREATE NEW SKILL",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          const body = {
            skillId: new Date().getTime(),
            activityType: activityType,
            usertype: usertype,
            language: "od",
            program: program,
            quizClass: level ? level : clas,
            subject: subject,
            skillName: input_value,
          };
          console.log("body---->", body);

          api
            .post(`saveMasterStudActSkill`, body)
            .then((response) => {
              console.log(
                "create_content_button_click_fln create---->",
                response.data
              );
              if (Object.keys(response.data).length > 0) {
                const body2 = {
                  activityType: response.data.activityType,
                  quizClass: response.data.quizClass,
                  language: response.data.language,
                  program: response.data.program,
                  subject: response.data.subject,
                  usertype: response.data.usertype,
                };

                dispatch(getTeacherBaselineFlnThunkSkill(body2));
                toast.success("Changes made successfully");
              }
            })
            .catch((error) => {
              if (error.response.status === 500) {
                toast.error("Internal server error.");
              } else if (error.response.status === 504) {
                toast.error("Server timeout. Please try again later.");
              } else {
                console.error("An unexpected error occurred:", error);
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
              }
              return false; // Prevent Swal from closing
            });
        }
      },
    });
  };

  const create_content_button_click_pge = () => {
    Swal.fire({
      title: "CREATE NEW SKILL",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          const body = {
            skillId: new Date().getTime(),
            activityType: activityType,
            usertype: usertype,
            language: "od",
            quizClass: clas,
            subject: subject,
            skillName: input_value,
          };
          console.log("body pge---->", body);

          api
            .post(`saveMasterStudActSkill`, body)
            .then((response) => {
              console.log("response create---->", response.data);
              if (Object.keys(response.data).length > 0) {
                const body3 = {
                  activityType: response.data.activityType,
                  quizClass: response.data.quizClass,
                  language: response.data.language,
                  subject: response.data.subject,
                  usertype: response.data.usertype,
                };
                dispatch(getTeacherBaselinePgeThunkSkill(body3));
                toast.success("Changes made successfully");
              }
            })
            .catch((error) => {
              if (error.response.status === 500) {
                toast.error("Internal server error.");
              } else if (error.response.status === 504) {
                toast.error("Server timeout. Please try again later.");
              } else {
                console.error("An unexpected error occurred:", error);
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
              }
              return false; // Prevent Swal from closing
            });
        }
      },
    });
  };

  const create_content_button_click_ece = () => {
    Swal.fire({
      title: "CREATE NEW SKILL",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          const body = {
            skillId: new Date().getTime(),
            activityType: activityType,
            usertype: usertype,
            language: "od",
            quizClass: level,
            // subject: subject,
            skillName: input_value,
          };
          console.log("body ece---->", body);

          api
            .post(`saveMasterStudActSkill`, body)
            .then((response) => {
              console.log("response create---->", response.data);
              if (Object.keys(response.data).length > 0) {
                const body3 = {
                  activityType: response.data.activityType,
                  quizClass: response.data.quizClass,
                  language: response.data.language,
                  usertype: response.data.usertype,
                };
                dispatch(getTeacherBaselineEceThunkSkill(body3));
                toast.success("Changes made successfully");
              }
            })
            .catch((error) => {
              if (error.response.status === 500) {
                toast.error("Internal server error.");
              } else if (error.response.status === 504) {
                toast.error("Server timeout. Please try again later.");
              } else {
                console.error("An unexpected error occurred:", error);
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
              }
              return false; // Prevent Swal from closing
            });
        }
      },
    });
  };

  // const create_content_button_click_community = () => {
  //   Swal.fire({
  //     title: "CREATE NEW SKILL",
  //     input: "text",
  //     inputAttributes: {
  //       autocapitalize: "off",
  //     },
  //     showCancelButton: true,
  //     confirmButtonText: "Save",
  //     showLoaderOnConfirm: true,
  //     preConfirm: (input_value) => {
  //       if (
  //         input_value === undefined ||
  //         input_value === null ||
  //         input_value.length <= 0
  //       )
  //         toast.error("Enter a valid skillset name");
  //       else {
  //         const body = {
  //           skillId: new Date().getTime(),
  //           activityType: activityType,
  //           usertype: usertype,
  //           language: "od",
  //           skillName: input_value,
  //         };
  //         console.log("body community---->", body);

  //         api.post(`saveMasterStudActSkill`, body).then((response) => {
  //           console.log("response create---->", response.data);
  //           if (Object.keys(response.data).length > 0) {
  //             const body3 = {
  //               activityType: response.data.activityType,
  //               language: response.data.language,
  //               usertype: response.data.usertype,
  //             };
  //             dispatch(getTeacherBaselineCommunityThunk(body3));
  //             toast.success("Changes made successfully");
  //           }
  //         });
  //       }
  //     },
  //   });
  // };
  // console.log(updateData, "updateData");
  const handleShowUpdate = (eachskill) => {
    const previousSkillName = eachskill.skillName;
    // console.log(eachskill, "each>>>");
    // setAnchorEl(false),
    Swal.fire({
      title: "Update NEW SKILL",
      input: "text",
      inputValue: previousSkillName,
      inputAttributes: {
        autocapitalize: "off",
      },

      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
          // input_value = eachskill.skillName
        )
          toast.error("Enter a valid skillset name");
        else {
          setUpdateData({
            skillId: eachskill.skillId,
            skillName: input_value,
            // _id: eachskill._id,
          });
          const data = {
            skillId: eachskill.skillId,
            skillName: input_value,
          };
          // console.log(data, "data>>>");
          // setShowUpdate(true);
          // dispatch(updateTeacherBaselineThunk(data));
          api
            .patch(`updateMasterStudActSkill`, data)
            .then(
              (response) => {
                console.log(
                  "response.data.program---",
                  response.data,
                  activityType
                );
                if (activityType === "fln") {
                  const body = {
                    language: "od",
                    usertype: usertype,
                    activityType: activityType,
                    program: program,
                    quizClass: clas ? clas : level,
                    subject: subject,
                  };
                  dispatch(getTeacherBaselineFlnThunkSkill(body));
                  toast.success("Changes made successfully");
                } else if (activityType === "pge") {
                  const body2 = {
                    language: language,
                    usertype: usertype,
                    activityType: activityType,
                    quizClass: clas,
                    subject: subject,
                  };
                  dispatch(getTeacherBaselinePgeThunkSkill(body2));
                  toast.success("Changes made successfully");
                } else if (activityType === "ece") {
                  const body3 = {
                    language: language,
                    usertype: usertype,
                    activityType: activityType,
                    quizClass: level,
                  };
                  dispatch(getTeacherBaselineEceThunkSkill(body3));
                  toast.success("Changes made successfully");
                }
                // else if (activityType === "community") {
                //   const body4 = {
                //     language: language,
                //     usertype: usertype,
                //     activityType: activityType,
                //   };
                //   dispatch(getTeacherBaselineCommunityThunk(body4));
                //   toast.success("Changes made successfully");
                // }
              },
              (err) => {
                console.log(err);
                toast.error("Enter a valid skill");
              }
            )
            .catch((error) => {
              if (error.response.status === 500) {
                toast.error("Internal server error.");
              } else if (error.response.status === 504) {
                toast.error("Server timeout. Please try again later.");
              } else {
                console.error("An unexpected error occurred:", error);
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
              }
              return false; // Prevent Swal from closing
            });
        }
      },
    });
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const [showUpdate, setShowUpdate] = useState(false);

  console.log("updateData---->", updateData);

  // const handleUpdateChanges = () => {
  //   const data = {
  //     skillId: updateData.skillId,
  //     skillName: updateData.skillName,
  //   };
  //   console.log("data--", data);
  //   api.patch(`updateMasterStudActSkill`, data).then(
  //     (response) => {
  //       console.log("response.data---", response.data);
  //       toast.success("Changes made successfully");
  //       const body = {
  //         activityType: activityType,
  //         usertype: usertype,
  //         language: "od",
  //         program: program,
  //         class: clas,
  //         subject: subject,
  //       };
  //       // dispatch(getTeacherBaselineThunk(body));
  //     },
  //     (err) => {
  //       console.log(err);
  //       toast.error("Enter a valid Quiz");
  //     }
  //   );

  //   setShowUpdate(false);
  // };

  const delete_content_button_click = (skillId) => {
    handleVertMenuClose();
    // console;
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteTeacherBaselineThunk(skillId)).then(() => {
          if (activityType === "fln") {
            const body = {
              language: "od",
              usertype: usertype,
              activityType: activityType,
              program: program,
              quizClass: clas ? clas : level,
              subject: subject,
            };
            dispatch(getTeacherBaselineFlnThunkSkill(body));
            toast.success("Changes made successfully");
          } else if (activityType === "pge") {
            const body2 = {
              language: language,
              usertype: usertype,
              activityType: activityType,
              quizClass: clas,
              subject: subject,
            };
            dispatch(getTeacherBaselinePgeThunkSkill(body2));
            toast.success("Changes made successfully");
          } else if (activityType === "ece") {
            const body3 = {
              language: language,
              usertype: usertype,
              activityType: activityType,
              quizClass: level,
            };
            dispatch(getTeacherBaselineEceThunkSkill(body3));
            toast.success("Changes made successfully");
          }
          // else if (activityType === "community") {
          //   const body4 = {
          //     language: language,
          //     usertype: usertype,
          //     activityType: activityType,
          //   };
          //   dispatch(getTeacherBaselineCommunityThunk(body4));
          //   toast.success("Changes made successfully");
          // }
          // toast.success("Changes made successfully");
        });
      }
    });
  };

  const clearState = () => {
    dispatch(usertype_change_skill("fellow"));
    dispatch(activityType_change_skill(""));
    dispatch(language_change_skill("od"));
    dispatch(program_change_skill(""));
    dispatch(clas_change_skill(""));
    dispatch(level_change_skill(""));
    dispatch(subject_change_skill(""));
    dispatch(clear_data_skill());
  };
  console.log("skill===>", skill);

  return (
    <>
      <div>
        <MuiHeader header="Skill" />

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Language"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Activitytype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={activityType}
            label="activityType"
            onChange={activitytype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {activitytype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {activityType === "fln" ? (
          <>
            <FormControl
              sx={{ m: 1, minWidth: 120, marginTop: 10 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Program</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={program}
                label="Program"
                onChange={program_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {program_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {program === "pge" ? (
              <>
                <FormControl
                  sx={{ m: 1, minWidth: 120, marginTop: 10 }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Class</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={clas}
                    label="Class"
                    onChange={clas_select_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {clas_select_option_list.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl
                  sx={{ m: 1, minWidth: 120, marginTop: 10 }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Subject</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={subject}
                    label="Subject"
                    onChange={subject_select_fln_pge_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {subject_select_option_list.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  onClick={create_content_button_click_fln}
                  variant="contained"
                >
                  <AddIcon />
                  Create New FLN
                </Button>
              </>
            ) : program === "ece" ? (
              <>
                <FormControl
                  sx={{ m: 1, minWidth: 120, marginTop: 10 }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Level</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={level}
                    label="Level"
                    onChange={level_select_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {Fln_level_select_option_list?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl
                  sx={{ m: 1, minWidth: 120, marginTop: 10 }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Subject</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={subject}
                    label="Subject"
                    onChange={subject_select_fln_ece_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {subject_select_option_list.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  onClick={create_content_button_click_fln}
                  variant="contained"
                >
                  <AddIcon />
                  Create New FLN
                </Button>
              </>
            ) : null}
          </>
        ) : activityType === "pge" ? (
          //  console.log()
          <>
            <FormControl
              sx={{ m: 1, minWidth: 120, marginTop: 10 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Class</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={clas}
                label="Class"
                onChange={clas_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {clas_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              sx={{ m: 1, minWidth: 120, marginTop: 10 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Subject</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={subject}
                label="Subject"
                onChange={subject_select_pge_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {subjects_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              onClick={create_content_button_click_pge}
              variant="contained"
            >
              <AddIcon />
              Create New pge
            </Button>
          </>
        ) : activityType == "ece" ? (
          //  console.log()
          <>
            <FormControl
              sx={{ m: 1, minWidth: 120, marginTop: 10 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Level</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={level}
                label="Level"
                onChange={level_select_ece_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {level_select_option_list?.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              onClick={create_content_button_click_ece}
              variant="contained"
            >
              <AddIcon />
              Create New ece
            </Button>
          </>
        ) : // : activityType === "community" ? (
        //   <>
        //     <Button
        //       onClick={create_content_button_click_community}
        //       variant="contained"
        //     >
        //       <AddIcon />
        //       Create New community
        //     </Button>
        //   </>
        // )
        null}

        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{
            minWidth: 80,
            alignItem: "right",
            backgroundColor: "blue",
            color: "black",
          }}
          size="small"
        >
          <UndoIcon style={{ color: "orange" }}></UndoIcon>
          Back
        </Button>
      </div>

      {/* Show List */}
      <div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {activityType ? (
              <>
                {skill?.length > 0
                  ? skill?.map((eachskill, index) => (
                      <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4}>
                        <Card sx={{ maxWidth: 345 }}>
                          <CardHeader
                            avatar={
                              <Avatar sx={{ bgcolor: purple[500] }}>
                                <AodIcon />
                              </Avatar>
                            }
                            action={
                              <>
                                <IconButton
                                  id={index + 1.1}
                                  onClick={(e) =>
                                    handleVertMenuClick(
                                      e,
                                      // eachskill._id,
                                      eachskill.skillId,
                                      eachskill.skillName
                                      // index
                                    )
                                  }
                                  // aria-controls={openVertMenu ? { index } : undefined}
                                  aria-expanded={
                                    openVertMenu ? "true" : undefined
                                  }
                                  aria-haspopup="true"
                                >
                                  {/* <MoreVertIcon /> */}
                                </IconButton>
                              </>
                            }
                            title={
                              <div
                                style={{
                                  cursor: "pointer",
                                  wordBreak: "break-all",
                                }}
                              >
                                {eachskill.skillName}
                                {console.log(eachskill, "skills>>")}
                              </div>
                            }
                          />
                          <Button
                            onClick={() =>
                              delete_content_button_click(eachskill?.skillId)
                            }
                          >
                            Delete
                          </Button>
                          <Button onClick={() => handleShowUpdate(eachskill)}>
                            edit
                          </Button>
                        </Card>
                        {/* <Menu
                      id={selectedIndex}
                      anchorEl={anchorEl}
                      open={openVertMenu}
                      onClose={handleVertMenuClose}
                      MenuListProps={{
                        "aria-labelledby": "vert-button",
                      }}
                      PaperProps={{
                        style: {
                          maxHeight: ITEM_HEIGHT * 4.5,
                          width: "20ch",
                        },
                      }}
                    >
                      <MenuItem onClick={() => handleShowUpdate(eachskill)}>
                        Edit
                      </MenuItem>
                      <MenuItem
                        onClick={() => delete_content_button_click(recordId)}
                      >
                        Delete
                      </MenuItem>
                      <Modal
                        open={showUpdate}
                        onClose={handleCloseUpdate}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          <FormControl
                            sx={{ m: 1, minWidth: 300 }}
                            size="small"
                          >
                            <TextField
                              // id="filled-basic"
                              label="Update Skill"
                              variant="filled"
                              value={updateData.skillName}
                              onChange={(e) =>
                                setUpdateData({
                                  ...updateData,
                                  skillName: e.target.value,
                                })
                              }
                            />
                          </FormControl>

                          <Button
                            variant="outlined"
                            style={{ marginLeft: 12 }}
                            onClick={handleCloseUpdate}
                          >
                            Close
                          </Button>
                          <Button
                            variant="contained"
                            onClick={handleUpdateChanges}
                          >
                            Update
                          </Button>
                        </Box>
                      </Modal>
                    </Menu> */}
                      </Grid>
                    ))
                  : ""}
              </>
            ) : (
              ""
            )}
          </Grid>
        </Box>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default FlnSkillsPage;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
